import styled, { css, keyframes } from 'styled-components'

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`

interface SpinnerProps {
    size?: string
    borderWidth?: string
}

/**
 * Common spinner component for loading states.
 * Use this across the codebase for consistent loading indicators.
 *
 * @example
 * <Spinner size="20px" />
 * <Spinner size="16px" borderWidth="2px" />
 */
export const Spinner = styled.div<SpinnerProps>(
    ({ theme, size = '20px', borderWidth = '2px' }) => css`
        width: ${size};
        height: ${size};
        border: ${borderWidth} solid ${theme.colors.tfwBlackOpacity10};
        border-top-color: ${theme.colors.tfwBlack87};
        border-radius: 50%;
        animation: ${spin} 0.8s linear infinite;
    `,
)

export const SpinnerContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${theme.spacing.large};
    `,
)

export default Spinner
